import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { solutionCycle } from '../../data/solutions';
import { fadeUp } from '../../utils/motion';
export function SolutionsCycle() {
  return <>
      <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-2496" data-mp="362q3vypjobri">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2497" data-mp="3a41n9mhts0r9">
          <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14" data-id="element-2498" data-mp="2w51xgbiktfti">
            <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-2499" data-mp="3145583pxy056">
              How a SyNeural engagement progresses
            </h2>
            <p className="lg:col-span-7 text-xl text-white/80 leading-relaxed lg:pt-3" data-id="element-2500" data-mp="2n6qacjgx505t">
              This describes how we work with an organization, not a single assessment cycle every domain uses.
              Research and Clinical engagements do not require HCF; the “develop capability” step applies only
              where capability development is part of the solution.
            </p>
          </motion.div>

          <motion.ol {...fadeUp} aria-label="How a SyNeural engagement progresses" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/15 border border-white/15 rounded-lg overflow-hidden" data-id="element-2501" data-mp="tqb982j1nnlz">
            {solutionCycle.map((step, index) => <li key={step} className="bg-navy-deep p-5 lg:p-6" data-id="element-2502" data-mp="fq0cwjyytgtf" data-mpi={index}>
                <span className="block text-xs font-medium text-teal mb-2" data-id="element-2503" data-mp="fsd5dr2cn9kq">{index + 1}</span>
                <span className="font-heading font-bold leading-snug" data-id="element-2504" data-mp="atjrvyn2bikk">{step}</span>
              </li>)}
          </motion.ol>

          <motion.div {...fadeUp} className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-2505" data-mp="kp3l2da8s35m">
            <p className="lg:col-start-6 lg:col-span-7 text-lg text-white/75 leading-relaxed" data-id="element-2506" data-mp="213d6ayj6tbs8">
              SKP helps people work with what is known and see how ideas relate.
              The Human Capability Framework defines how people’s learning,
              judgment, and growth can be assessed and developed. Noetivra makes
              both accessible in practice. Together, they support SyNeural’s wider vision:{' '}
              <span className="text-white font-semibold" data-id="element-2507" data-mp="2d7h5bvfpkdzz">
                building intelligence in the world—in research, in people, and
                in the institutions they create.
              </span>
            </p>
          </motion.div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-28" data-id="element-2508" data-mp="1pfsb29jbtfge">
        <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2509" data-mp="1peh98f9fyhrx">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-6" data-id="element-2510" data-mp="1udlgh0ct25fm">
            Build a solution with SyNeural
          </h2>
          <p className="text-xl text-ink-muted leading-relaxed mb-10" data-id="element-2511" data-mp="11pxvhk7mhcsg">
            The starting point is a specific question or challenge. We can
            design a research knowledge system, a human capability pilot, or an
            institutional workflow around what your organization needs to
            understand and improve.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2512" data-mp="3fwxf9rvysa5s">
            <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-navy text-white hover:bg-navy-light font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2513" data-mp="3axueijn0oq3m">
              Contact Us
              <ArrowRight size={18} data-id="element-2514" data-mp="2w9zlf253kjq0" />
            </a>
            <a href="/partnerships" className="inline-flex items-center justify-center border border-line text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2515" data-mp="2s8xt759ll7xj">
              Start a Partnership Conversation
            </a>
          </div>
        </motion.div>
      </section>
    </>;
}